module.exports = __webpack_public_path__ + "static/media/nosotros04M.109f8b05.jpg";